export const isValidLandingPage = content => {
  if (!content) {
    return true;
  }
  const hasLanguageVariations = Boolean(content.translations && Object.keys(content.translations).length > 0);
  const isPublic = !content.audienceAccess || content.audienceAccess === 'PUBLIC';
  return !hasLanguageVariations && !content.variation && !content.abStatus && isPublic;
};